<div class="flex items-center justify-between">
    <span class="flex grow flex-col">
      <span class="text-sm text-light mr-2 inline-block" id="availability-description" >
        {{ label | translate }}
        @if (showStatusOnLabel){
            ({{ (value ? 'on' : 'off') | translate }})
        }
      </span>
    </span>
    <button
            type="button"
            [disabled]="disabled"
            [ngClass]="{
      'bg-primary': value,
      'bg-normal': !value
    }"
            (click)="toggleValue()"
            class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:outline-button-primary-outline"
            role="switch"
            [attr.aria-checked]="value"
            aria-labelledby="availability-label"
            aria-describedby="availability-description">
    <span
            aria-hidden="true"
            [ngClass]="{
        'translate-x-5': value,
        'translate-x-0': !value
      }"
            class="pointer-events-none inline-block size-5 transform rounded-full bg-border shadow ring-0 transition duration-200 ease-in-out">
    </span>
    </button>
</div>
